import {
  DELETE_UPLOAD,
  EDIT_UPLOAD_ITEM,
  FIND_AUTHORS,
  GET_ACCESS_LEVEL,
  GET_AUTHORSHIP_TYPES,
  GET_IDENTITY_SYSTEM,
  GET_LANGUAGES,
  GET_PUBLICATION_THEMATIC,
  GET_PUBLICATION_TYPE,
  GET_SCIENCE_AREA,
  GET_SCIENCE_FIELD,
  GET_UPLOADS,
  GET_UPLOAD_CATALOG,
  GET_UPLOAD_FILE_EXTENTIONS,
  GET_UPLOAD_FILE_MIME,
  POST_UPLOAD,
  PUBLISH_UPLOAD_ITEM,
  PUT_UPLOAD_ITEM,
  SWITCH_UPLOAD_LIST_FILTER,
} from 'redux/constants';
import { DeleteItemPayload, SwitchUploadListFilterPayload } from 'redux/actions/profileActions';
import {
  GetUploadsPayload,
  PutUploadItemPayload,
  deleteUploadFailed,
  deleteUploadSuccess,
  editUploadItemFailed,
  editUploadItemSuccess,
  findAuthorsFailed,
  findAuthorsSuccess,
  getUploadsFailed,
  getUploadsSuccess,
  postUploadFailed,
  postUploadSuccess,
  publishUploadItemFailed,
  publishUploadItemSuccess,
  putUploadItemFailed,
  putUploadItemSuccess,
  setLoadingCatalogs,
  switchUploadListFilterFailed,
  switchUploadListFilterSuccess,
} from 'redux/actions/uploadActions';
import { Upload, UploadItem } from 'types/uploadType';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  getAccessLevelHandler,
  getAuthorshipTypesHandler,
  getContentTypesHandler,
  getIdentitySystemHandler,
  getLanguagesHandler,
  getPublicationThematicHandler,
  getPublicationTypeHandler,
  getScienceAreaHandler,
  getScienceFieldHandler,
  getUploadFileExtentionsHandler,
  getUploadFileMimeHandler,
} from './clsSaga';
import { ActionType } from 'types/reduxTypes';
import { ClsItem } from 'types/clsType';
import { GetClsItemsPayload } from 'redux/actions/clsActions';
import config from 'shared/config';
import { getClsItemsAsync } from './clsSaga';
import safeAxios from 'shared/api/safeFetch';
import { transformFilterValues } from 'utils/upload.utils';

function* editUploadItemHandler({ payload }: ActionType<UploadItem>) {
  if (payload.id) {
    try {
      const { data } = yield call(safeAxios, `${config.apiUrl}/upload/item/${payload.id}`, {
        headers: {
          Accept: 'application/json',
        },
        method: 'GET',
      });
      yield put(editUploadItemSuccess(data));
    } catch (error) {
      yield put(editUploadItemFailed({ message: '' }));
    }
  } else {
    yield put(editUploadItemSuccess(payload));
  }
}

function* getUploadCatalogsHandler({ payload }: ActionType<GetClsItemsPayload>) {
  yield put(setLoadingCatalogs(true));
  yield call(getUploadFileExtentionsHandler, { payload, type: GET_UPLOAD_FILE_EXTENTIONS });
  yield call(getUploadFileMimeHandler, { payload, type: GET_UPLOAD_FILE_MIME });
  yield call(getPublicationTypeHandler, { payload, type: GET_PUBLICATION_TYPE });
  yield call(getPublicationThematicHandler, { payload, type: GET_PUBLICATION_THEMATIC });
  yield call(getScienceFieldHandler, { payload, type: GET_SCIENCE_FIELD });
  yield call(getScienceAreaHandler, { payload, type: GET_SCIENCE_AREA });
  yield call(getLanguagesHandler, { payload, type: GET_LANGUAGES });
  yield call(getAuthorshipTypesHandler, { payload, type: GET_AUTHORSHIP_TYPES });
  yield call(getIdentitySystemHandler, { payload, type: GET_IDENTITY_SYSTEM });
  yield call(getAccessLevelHandler, { payload, type: GET_ACCESS_LEVEL });
  yield call(getContentTypesHandler, { payload, type: GET_ACCESS_LEVEL });
  yield put(setLoadingCatalogs(false));
}

function* getUploadsHandler({
  payload: { filterParams, isAppend, isPublished, page, pageSize },
}: ActionType<GetUploadsPayload>) {
  try {
    const { data } = yield call(safeAxios, `${config.apiUrl}/upload/find`, {
      body: {
        filters: filterParams?.filters?.map((e) => {
          return {
            jsonParams: JSON.stringify(transformFilterValues(e.jsonValues)),
            jsonPath: e.jsonPath,
          };
        }),
        page,
        pageSize,
        published: isPublished ?? false,
        uploadItemType: filterParams?.type,
      },
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    yield put(getUploadsSuccess({ data, isAppend }));
  } catch (error) {
    yield put(getUploadsFailed({ message: '' }));
  }
}

function* postUploadHandler({ payload }: ActionType<Upload>) {
  try {
    const { data } = yield call(safeAxios, `${config.apiUrl}/upload`, {
      body: payload,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    yield put(postUploadSuccess(data));
  } catch (error) {
    yield put(postUploadFailed({ message: '' }));
  }
}

function* publishUploadItemHandler({ payload: uploadId }: ActionType<string>) {
  try {
    const { data } = yield call(safeAxios, `${config.apiUrl}/upload/${uploadId}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    yield put(publishUploadItemSuccess(data));
  } catch (error) {
    console.error(error);
    yield put(publishUploadItemFailed({}));
  }
}

function* putUploadItemHandler({ payload: { uploadItem, filesToRemove } }: ActionType<PutUploadItemPayload>) {
  try {
    const { data } = yield call(safeAxios, `${config.apiUrl}/upload/item`, {
      body: uploadItem,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'PUT',
    });
    for (let i = 0; i < filesToRemove.length; i++) {
      const id = filesToRemove[i].id;
      if (id) {
        try {
          yield call(safeAxios, `${config.apiUrl}/upload/item/file/${id}`, {
            headers: {
              Accept: 'application/json',
            },
            method: 'DELETE',
          });
        } catch (e) {}
      }
    }
    yield put(putUploadItemSuccess(data));
  } catch (error) {
    yield put(putUploadItemFailed({ message: '' }));
  }
}

function* deleteUploadHandler(action: ActionType<DeleteItemPayload>) {
  try {
    const { data } = yield call(safeAxios, `${config.apiUrl}/upload/${action.payload.itemId}`, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    });
    yield put(deleteUploadSuccess(data));
  } catch (error) {
    yield put(deleteUploadFailed({ message: '' }));
  }
}

function* findAuthorsHandler({ payload }: ActionType<string>) {
  try {
    const requestParams = new URLSearchParams({
      query: payload,
    });
    const { data } = yield call(safeAxios, `${config.apiUrl}/author/find?${requestParams}`, {
      headers: {
        Accept: 'application/json',
      },
      method: 'GET',
    });
    yield put(findAuthorsSuccess(data));
  } catch (error) {
    yield put(findAuthorsFailed({ message: '' }));
  }
}

function* switchUploadListFilterHandler({ payload: { filters, lang } }: ActionType<SwitchUploadListFilterPayload>) {
  try {
    if (filters) {
      const catalogs: Record<number, ClsItem[]> = {};
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];
        const { data } = yield call(getClsItemsAsync, {
          cls: filter.cls,
          lang,
          page: 1,
          pageSize: 10000,
        });
        catalogs[filter.cls] = data?.sort((a: ClsItem, b: ClsItem) => a.term.localeCompare(b.term));
      }
      yield put(
        switchUploadListFilterSuccess({
          catalogs,
          loading: false,
        })
      );
    } else {
      yield put(
        switchUploadListFilterSuccess({
          catalogs: {},
          loading: false,
        })
      );
    }
  } catch (error) {
    yield put(switchUploadListFilterFailed({ message: '' }));
  }
}

export default function* fetchUploadWatcher(): Generator {
  yield takeEvery(EDIT_UPLOAD_ITEM, editUploadItemHandler);
  yield takeEvery(GET_UPLOADS, getUploadsHandler);
  yield takeEvery(POST_UPLOAD, postUploadHandler);
  yield takeEvery(DELETE_UPLOAD, deleteUploadHandler);
  yield takeEvery(PUT_UPLOAD_ITEM, putUploadItemHandler);
  yield takeEvery(GET_UPLOAD_CATALOG, getUploadCatalogsHandler);
  yield takeEvery(FIND_AUTHORS, findAuthorsHandler);
  yield takeEvery(SWITCH_UPLOAD_LIST_FILTER, switchUploadListFilterHandler);
  yield takeEvery(PUBLISH_UPLOAD_ITEM, publishUploadItemHandler);
}
